import * as React from 'react';
import { LinkButton } from '@/components/buttons';
import { format, R } from '@/features/booking/resources/Texts.resx';

type InsuranceProviderInfoCardProps = {
    insuranceProviderName?: string;
    insuranceProviderLogoPath?: string;
};

export function InsuranceProviderInfoCard({
    insuranceProviderName,
    insuranceProviderLogoPath,
}: InsuranceProviderInfoCardProps) {
    const hasProvider = !!insuranceProviderName;

    return (
        <div className="border-stroke space-y-4 rounded-2xl border bg-gray-100 p-4">
            {hasProvider && insuranceProviderLogoPath && (
                <div className="flex h-12 w-fit flex-row rounded-2xl bg-white px-4">
                    <div className="self-center pr-4 text-sm font-normal text-gray-500">
                        {R.AccessVia}
                    </div>
                    <img
                        className="max-h-8 max-w-14 self-center"
                        src={insuranceProviderLogoPath}
                        alt={`${insuranceProviderName} logo`}
                    />
                </div>
            )}

            <p className="text-primary mt-0 font-bold">
                {hasProvider
                    ? format(
                          R.InsuranceProviderInfoCardWithProviderTitle,
                          insuranceProviderName,
                      )
                    : R.InsuranceProviderInfoCardNoProviderTitle}
            </p>

            {hasProvider ? (
                <>
                    <p>
                        {format(
                            R.InsuranceProviderInfoCardWithProviderParagraph1,
                            insuranceProviderName,
                        )}
                    </p>
                    <p>{R.InsuranceProviderInfoCardWithProviderParagraph2}</p>
                </>
            ) : (
                <p>{R.InsuranceProviderInfoCardNoProviderParagraph}</p>
            )}

            <div className="flex justify-end">
                <LinkButton
                    href={
                        hasProvider
                            ? '/profile/insurancepartnerdetails'
                            : '/profile/access'
                    }
                    variant="secondary"
                    outline={true}
                >
                    {R.InsuranceProviderInfoCardGoToProfile}
                </LinkButton>
            </div>
        </div>
    );
}
